import { CommonModule } from '@angular/common';
import { FormsModule, ReactiveFormsModule } from '@angular/forms';
import { NgModule } from '@angular/core';
import { RouterModule } from '@angular/router';
import { TranslateModule } from '@ngx-translate/core';
import { FileUploadModule } from 'ng2-file-upload';
import { ClipboardModule } from 'ngx-clipboard';
import { AngularSvgIconModule } from 'angular-svg-icon';
import { SharedModule } from '../shared/shared.module';
import { routes } from './projects.routes';
import { NgxFileDropModule } from 'ngx-file-drop';
import { WelcomeComponent } from './contrib/welcome/welcome.component';
import { ContainerComponent } from './contrib/container/container.component';
import { UploadComponent } from './contribWizard/upload/upload.component';
import { ContribComponent } from './contrib/contrib.component';
import { ContribService } from './contrib/contrib.service';
import { ContribWizardComponent } from './contribWizard/contribWizard.component';
import { WaitingComponent } from './contribWizard/waiting/waiting.component';
import { UploadService } from './contribWizard/upload/upload.service';
import { FacebookLoginComponent } from 'app/+account/facebook-login/facebook-login.component';
import { AccountModule } from 'app/+account/account.module';
import { FinishComponent } from './contrib/finish/finish.component';
import { StoriesModule } from 'app/+stories/stories.module';
import { ContribLoginComponent } from './contrib/contribLogin/contribLogin.component';
import { ShowInvitationStoryComponent } from './show/show.component';
import { NotFoundComponent } from './contrib/not-found/not-found.component';

@NgModule({
  declarations: [
    ContainerComponent,
    WelcomeComponent,
    UploadComponent,
    ContribComponent,
    ContribLoginComponent,
    ContribWizardComponent,
    WaitingComponent,
    FinishComponent,
    ShowInvitationStoryComponent,
    NotFoundComponent,
  ],
  imports: [
    StoriesModule,
    CommonModule,
    FormsModule,
    ReactiveFormsModule,
    RouterModule.forChild(routes),
    FileUploadModule,
    ClipboardModule,
    AngularSvgIconModule,
    SharedModule,
    NgxFileDropModule,
    AccountModule,
    TranslateModule,
  ],
  providers: [
    UploadService,
    ContribService,
  ],
})
export class ProjectsModule {
  public static routes = routes;
}
